exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-checkbox input[type=\"checkbox\"] {\n  display: block;\n  position: relative;\n  margin-left: 10px;\n  height: 4.4rem;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/borneo/prod/borneo_app/src/app/shared/components/forms/custom-checkbox-field/custom-checkbox-field.component.css
// module id = ../../../../../src/app/shared/components/forms/custom-checkbox-field/custom-checkbox-field.component.css
// module chunks = main